import Layout from '@/layout'

const asyncContractRoutes = {
  path: '/purchase/contract',
  component: Layout,
  redirect: 'noRedirect',
  name: '合同管理',
  funcPerms: '',
  meta: {
    title: '合同管理',
    icon: '',
    affix: false,
    noCache: false
  },
  children: [
    {
      path: '/purchase/contract/apply/purchase_11',
      component: () => import('@/views/purchase/purchaseContract/myProcess/index.vue'),
      name: '我的合同申请',
      funcPerms: 'purchase:contract:apply:my',
      meta: {
        title: '我的合同申请',
        icon: '',
        affix: false,
        noCache: false
      }
    },
    {
      path: '/purchase/contract/pass/purchase_11',
      component: () => import('@/views/purchase/purchaseContract/todo/index.vue'),
      name: '我未审批的合同',
      funcPerms: 'purchase:contract:apply:my:todo',
      meta: {
        title: '我未审批的合同',
        icon: '',
        affix: false,
        noCache: false
      }
    },
    {
      path: '/purchase/contract/my/finished/purchase_11',
      component: () => import('@/views/purchase/purchaseContract/finished/index.vue'),
      name: '我已审批的合同',
      funcPerms: 'purchase:contract:apply:my:finished',
      meta: {
        title: '我已审批的合同',
        icon: '',
        affix: false,
        noCache: false
      }
    },
    {
      path: '/purchase/contract/list',
      component: () => import('@/views/purchase/purchaseContract/list/index.vue'),
      name: '合同列表',
      funcPerms: 'purchase:contract:apply:list:all',
      meta: {
        title: '合同列表',
        icon: '',
        affix: false,
        noCache: false
      }
    }
  ]
}

export default asyncContractRoutes
